import { CommApiInstance } from "Utils/CommApiInstance";


const GameSvcMnyDpstPrdtLstApi = async (
    gameSvcCd:string|null,
    prdtKindCd:string,
    nowPageNo:string|number|null,
    srchStr:string|null,
) => {
    return await CommApiInstance.post(`pymt/${gameSvcCd}/${prdtKindCd}/prdt_lst?page=${nowPageNo}&srch=${srchStr}`,{
        apiBody: {
        }
    })
    .then((Resp) => Resp.data);
}

export default GameSvcMnyDpstPrdtLstApi;